import { useCallback, useMemo, useContext, useEffect, useRef, useState } from "react";
import UIkit from "uikit";
import { InputContainer } from "uikit-react";
import classnames from "classnames";

import { AppContexts } from "../../providers";
import { InputRadio, Form, FormRow, FormInputWrapper } from "../../ui";
import utils from "../../utils/utils";

const EditUnitDetails = ({ unit }) => {
  const {
    macroLogs,
    updateMacroValue,
  } = useContext(AppContexts.RentalsContext);
  const {
    getMacros,
  } = useContext(AppContexts.ReportsContext);
  console.log(macroLogs);

  const [content, setContent] = useState('');
  const [error, setError] = useState({});
  const offcanvasRef = useRef(null);

  useEffect(() => {
    setContent(unit?.content);
    setError({});
  }, [unit]);

  const handleBeforeHide = () => {
    setContent('');
  }

  useEffect(() => {
    const offcanvasElement = UIkit.offcanvas(offcanvasRef.current);
    const offcanvasDOMElement = offcanvasElement.$el;
    offcanvasDOMElement.addEventListener("beforehide", handleBeforeHide);
    return () => {
      offcanvasDOMElement.removeEventListener("beforehide", handleBeforeHide);
    };
  }, []);

  const handleRegister = async () => {
    if (!content) {
      setError({ content: { message: "This is required." }});
    } else {
      try {
        await updateMacroValue({
          macro_id: unit.id,
          rental_id: unit.rental_id,
          content: content,
        });
        UIkit.modal("#edit-unit-details").hide();
        await getMacros();
      } catch (err) {
        UIkit.notification("Failed", "error");
      }
    }
  };

  return (
    <>
      <div
        id="edit-unit-details"
        ref={offcanvasRef}
        className="uk-modal-full hms-modals uk-modal uk-open"
        uk-offcanvas="flip: true; overlay: true"
      >
        <div className="uk-offcanvas-bar">
          <div className="hms-modals-main">
            <button
              className="uk-offcanvas-close uk-close-large"
              type="button"
              uk-close="true"
            ></button>
            <div className="uk-modal-header">
              <h2 className="uk-modal-title">Edit {unit?.field}</h2>
            </div>
            <div className="uk-modal-body uk-flex">
              <Form
                className="uk-grid-small"
                uk-grid="true"
              >
                {unit?.category !== 'Unsynced' && <p>Property data syncs every hour, so updates may be overwritten.</p>}
                <FormRow>
                  <FormInputWrapper label="Value*" size="two">
                    <InputContainer>
                      <textarea
                        className={classnames("uk-textarea", { error: error.content })}
                        rows="5"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                    </InputContainer>
                  </FormInputWrapper>
                </FormRow>
                <div>
                  <button
                    className="uk-button hms-btn hms-red-btn"
                    type="button"
                    onClick={handleRegister}
                  >
                    Save
                  </button>
                  <button
                    className="uk-button hms-btn uk-offcanvas-close"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
                {/*
                {macroLogs?.map((log) => (
                  <p>{utils.composeLog(log)}</p>
                ))}
                */}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUnitDetails;
